import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  agentNoticesService,
  type AgentNoticePolicy,
  type DecisionsQuery,
} from '@/services/agentNoticesService'
import { queryKeys } from '../keys'

export function useAgentNoticePolicyQuery() {
  return useQuery({
    queryKey: queryKeys.agentNotices.policy(),
    queryFn: () => agentNoticesService.getPolicy(),
  })
}

export function useAgentNoticeDecisionsQuery(params: DecisionsQuery) {
  return useQuery({
    queryKey: queryKeys.agentNotices.decisions(params),
    queryFn: () => agentNoticesService.listDecisions(params),
    placeholderData: keepPreviousData,
  })
}

export function useUpdateAgentNoticePolicy() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: AgentNoticePolicy) => agentNoticesService.updatePolicy(data),
    onSuccess: (policy) => queryClient.setQueryData(queryKeys.agentNotices.policy(), policy),
  })
}
